import { render, staticRenderFns } from "./sendCardWhats.vue?vue&type=template&id=6d289ace"
import script from "./sendCardWhats.vue?vue&type=script&lang=js"
export * from "./sendCardWhats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports